module.exports = __webpack_public_path__ + "img/fi-rr-file-delete.66f33c63.svg";